/**
 * Форматирует размер файла в человекочитаемый текст
 * @param {number} bytes - Размер в байтах
 * @returns {string} - Отформатированная строка
 */
export const formatFileSize = (bytes) => {
    if (!bytes) return '—';
    if (bytes < 1024) return `${bytes} Б`;
    if (bytes < 1024 ** 2) return `${(bytes / 1024).toFixed(1)} КБ`;
    if (bytes < 1024 ** 3) return `${(bytes / 1024 ** 2).toFixed(1)} МБ`;
    if (bytes < 1024 ** 4) return `${(bytes / 1024 ** 3).toFixed(2)} ГБ`;
    return `${(bytes / 1024 ** 4).toFixed(2)} ТБ`;
};
